import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import TablePagination from '@mui/material/TablePagination'
import styled from 'styled-components'

import { useAppSelector, useAppDispatch } from 'redux/Hook'
import {
  PaginationRowsOptions,
  CardPaginationProps,
  MouseEvent,
  ChangeEvent,
} from 'types/TextAnalysis'
import { getSelectedCurrentRows } from '../Helpers/BulkSelectHelpers'
import { resetSelectedContributions } from 'redux/slices/TextAnalysis'
import CardSelectedCount from './CardSelectedCount'

const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .MuiTablePagination-toolbar {
    padding: 0;
  }
  @media only screen and (max-width: 700px) {
    justify-content: center;
  }
`

const CardPagination = ({
  count,
  page,
  pageSize,
  onPageChange,
  onRowsPerPageChange,
  clearBulkSelect,
}: CardPaginationProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { data: currentRows, selectedContributions: selectedRows } =
    useAppSelector((state) => state.textAnalysis)

  const allSelectedCount = useMemo(
    () => getSelectedCurrentRows(selectedRows, currentRows),
    [currentRows, selectedRows],
  )

  const handlePaginationChange = (_: MouseEvent, newPage: number) => {
    if (clearBulkSelect) dispatch(resetSelectedContributions())
    onPageChange(newPage)
  }

  const handleChangeRowsPerPage = (event: ChangeEvent) => {
    const pageSize = Number(event.target.value)
    onRowsPerPageChange(pageSize)
    onPageChange(0)
  }

  return (
    <PaginationContainer>
      <CardSelectedCount count={allSelectedCount.length} />
      <TablePagination
        component="div"
        id="card-pagination"
        labelRowsPerPage={`${t('participant.grid.rowsPerPage')}:`}
        count={count}
        page={page}
        onPageChange={handlePaginationChange}
        rowsPerPage={pageSize}
        rowsPerPageOptions={PaginationRowsOptions}
        onRowsPerPageChange={handleChangeRowsPerPage}
        SelectProps={{
          inputProps: {
            'aria-label': 'rows per page',
            'aria-labelledby': 'rowsperPage',
          },
          id: 'rowsperPage',
        }}
      />
    </PaginationContainer>
  )
}

export { CardPagination }
